// my-theme.ts
import { DefaultTheme } from "styled-components";

const divertidogsTheme: DefaultTheme = {
  fontPrimary: "Lato",

  colors: {
    main: "#A833B9",
    secondary: "#91F0E1",
    light: "#F1EBE9",
    warning: "#FCCC5E",
    success: "#379634",
    error: "#DD403A",
    textNeutral: "#BBBEC5",
    info: "#03A9F4",
    mainShadow: "#eecdf3",
    successShadow: "#dffcde",
    warningShadow: "#faf1dc",
    dangerShadow: "#f7c6c3",
    blueShadow: "#C3F4F7",
    blue: "#19b4bc",
  },
};

export { divertidogsTheme };
